import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { IoDocumentTextOutline, IoCalendarOutline } from "react-icons/io5";
import { FiEdit, FiArrowLeft, FiPlus } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { projectStatusList } from "../../jsons/projectStatusList";
import axios from "axios";
import useAuth from "../../useAuth";
import { toast } from "react-toastify";
import { server } from "../../server";
import { IoMdPersonAdd } from "react-icons/io";
import { Modal, Box, Pagination } from "@mui/material";
import { IoClose, IoPersonAddSharp } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import LoadingComponent from "../../Components/LoadingComponent";

export default function ProjectDetails() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { projectData } = location?.state;
  const [projectDetails, setProjectDetails] = useState("");
  const [addPartnerModel, setAddPartnerModel] = useState(false);
  const [sync, setSync] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getProjectDetails();
  }, [sync]);

  const getProjectDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/project/getById`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          projectId: projectData?.id,
        },
      });
      setLoading(false);
      setProjectDetails(data?.data);
    } catch (e) {
      setLoading(false);
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  console.log(projectDetails);

  return (
    <div className="min-h-screen p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-5xl mx-auto"
      >
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <IoDocumentTextOutline className="text-3xl text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-800">
              Project Details
            </h1>
          </div>

          <div className="flex gap-3">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 border border-gray-300 rounded-lg px-4 py-2 hover:bg-gray-100 transition bg-gray-100"
            >
              <FiArrowLeft /> Back
            </button>
            <button
              disabled={projectDetails?.createdById !== user?.id}
              className="disabled:text-gray-400 disabled:bg-gray-100 disabled:border-gray-200 disabled:cursor-not-allowed flex items-center gap-2 border border-blue-600 text-blue-600 rounded-lg px-4 py-2 hover:bg-blue-600 hover:text-white transition bg-blue-100"
            >
              <FiEdit /> Edit
            </button>
            {user?.userType === "admin" && (
              <button
                className="flex items-center gap-2 border border-green-600 text-green-700 rounded-lg px-4 py-2 hover:bg-green-700 hover:text-white transition bg-green-100"
                onClick={() => setAddPartnerModel(true)}
              >
                <IoMdPersonAdd /> Add Partner
              </button>
            )}
          </div>
        </div>

        {/* Project Overview */}
        <div className="bg-white rounded-xl shadow p-6 mb-6 border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            {projectDetails.projectName}
          </h2>
          <p className="text-gray-700">{projectDetails.description}</p>
        </div>

        {/* Project Details */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {/* Timeline */}
          <div className="bg-white rounded-xl shadow p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <IoCalendarOutline /> Timeline
            </h3>
            <div className="space-y-2 text-gray-700">
              <div className="flex items-center">
                <div className="w-32">
                  <strong>Start Date:</strong>
                </div>
                {projectDetails.startDate
                  ? new Date(Number(projectDetails.startDate))?.toDateString(
                      "en-In"
                    )
                  : "---"}
              </div>
              <div className="flex items-center">
                <div className="w-32">
                  <strong>End Date:</strong>
                </div>
                {projectDetails.endDate
                  ? new Date(Number(projectDetails.endDate))?.toDateString(
                      "en-In"
                    )
                  : "---"}
              </div>
              <div className="flex items-center">
                <div className="w-32">
                  <strong>Status:</strong>
                </div>
                <span
                  className={`px-2 py-1 font-medium rounded  ${
                    projectDetails.status === "Completed"
                      ? "bg-green-100 text-green-600"
                      : projectDetails.status === "In Progress"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-gray-200 text-gray-600"
                  }`}
                >
                  {
                    projectStatusList?.find(
                      (e) => e?.slug === projectDetails.status
                    )?.label
                  }
                </span>
              </div>
            </div>
          </div>

          {/* Owner */}
          <div className="bg-white rounded-xl shadow p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <IoDocumentTextOutline /> Owner
            </h3>
            <div className="text-gray-700 space-y-2">
              <div className="flex items-center">
                <div className="w-32">
                  <strong>Project Owner:</strong>
                </div>
                {projectDetails?.projectOwner || "---"}
              </div>
              <div className="flex items-center">
                <div className="w-32">
                  <strong>State:</strong>
                </div>
                {projectDetails.state || "---"}
              </div>

              <div className="flex items-center">
                <div className="w-32">
                  <strong>District:</strong>
                </div>
                {projectDetails.district || "---"}
              </div>

              <div className="flex items-center">
                <div className="w-32">
                  <strong>Reg. By:</strong>
                </div>
                {projectDetails.createdBy || "---"}
              </div>

              <div className="flex items-center">
                <div className="w-32">
                  <strong>Reg. At:</strong>
                </div>
                {new Date(projectDetails.createdAt)?.toDateString("en-In") ||
                  "---"}
              </div>
            </div>
          </div>

          {/* Partner */}
          <div className="bg-white rounded-xl shadow p-6 border border-gray-200">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <IoDocumentTextOutline /> Partners
            </h3>
            <div className="text-gray-700 space-y-2">
              {projectDetails?.partners?.length > 0 ? (
                <ul className="list-disc list-inside space-y-1">
                  {projectDetails?.partners?.map((e, i) => (
                    <li key={i}>{e}</li>
                  ))}
                </ul>
              ) : (
                <div className="flex items-center gap-2 bg-yellow-50 border border-yellow-200 text-yellow-800 p-3 rounded-lg">
                  <svg
                    className="w-5 h-5 text-yellow-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10A8 8 0 112 10a8 8 0 0116 0zm-8-4a1 1 0 00-.993.883L9 7v4a1 1 0 001.993.117L11 11V7a1 1 0 00-1-1zm0 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <p className="text-sm font-medium">
                    No partners have been added yet.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Project Updates */}
        <ProjectUpdates projectData={projectData} />
      </motion.div>

      {addPartnerModel && (
        <AddPartnerModel
          projectData={projectDetails}
          setOpen={setAddPartnerModel}
          setSync={setSync}
        />
      )}

      {loading && <LoadingComponent />}
    </div>
  );
}

const ProjectUpdates = ({ projectData }) => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [projectUpdates, setProjectsUpdates] = useState([]);
  const [updatesCount, setUpdatesCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    getProjectUpdates();
  }, [pageNo]);

  const getProjectUpdates = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/projectUpdate/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          projectId: projectData?.id,
          pageNo,
          pageSize,
          searchParams,
          deleted: false,
        },
      });
      setProjectsUpdates(data?.data);
      setUpdatesCount(data?.count);
      setLoading(false);
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message);
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        {/* Project Updates Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
            Project Updates [{updatesCount}]
          </h2>
          <button
            onClick={() =>
              navigate("../addProjectUpdate", { state: { projectData } })
            }
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            <FiPlus /> Add Update
          </button>
        </div>

        {/* Project Updates List */}
        <div className="space-y-4">
          {projectUpdates.length === 0 ? (
            <p className="text-gray-500">
              No updates available for this project.
            </p>
          ) : (
            projectUpdates.map((e, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: e.Id * 0.1 }}
                className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300 relative"
              >
                {/* Title and Date */}
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-xl font-bold text-gray-900 tracking-tight">
                    {e?.updateTitle}
                  </h3>
                </div>

                {/* Description */}
                <p className="text-gray-700  leading-relaxed mb-4">
                  {e?.updateDescription}
                </p>

                {/* Document */}
                {e?.documentUrl && (
                  <div className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg p-3">
                    <div className="text-gray-800 font-medium truncate">
                      📄 {e?.documentUrl?.split("_")?.[1]}
                    </div>
                    <a
                      href={e?.documentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1 rounded-lg transition-all duration-200"
                    >
                      View
                    </a>
                  </div>
                )}

                {/* Created By */}
                <p className="absolute top-2 right-2 text-xs capitalize text-gray-800 mb-2 bg-gray-200 rounded-full px-2 py-1">
                  By-{" "}
                  <span className="font-medium text-gray-700">
                    {e?.createdBy || "N/A"}&nbsp;|&nbsp;
                    {new Date(e?.createdAt)?.toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                </p>
              </motion.div>
            ))
          )}
        </div>

        {/* Pagination */}
        {updatesCount > pageSize && (
          <div className="flex justify-end mt-6">
            <Pagination
              count={Math.ceil(updatesCount / pageSize)}
              page={pageNo}
              onChange={(event, value) => setPageNo(value)}
              color="primary"
              shape="rounded"
            />
          </div>
        )}
      </div>

      {loading && <LoadingComponent />}
    </div>
  );
};

const AddPartnerModel = ({ setOpen, projectData, setSync }) => {
  const [selectedPartner, setSelectedPartner] = useState("");
  const [partnersList, setPartnersList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPartnersList();
  }, []);

  const fetchPartnersList = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/auth/getOrganizationUsers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          pageNo: 1,
          pageSize: 1000,
        },
      });
      setSync((prv) => prv + 1);
      setLoading(false);
      setPartnersList(data?.data);
    } catch (e) {
      setLoading(false);
      return toast.error(e?.response?.data?.message || e?.message);
    }
  };

  const handleAddPartner = async () => {
    try {
      setLoading(true);

      const { data } = await axios.put(`${server}/project/addPartner`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          projectId: projectData?.id,
          partnerId: selectedPartner,
        },
      });

      toast.success(data?.message);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e?.response?.data?.message || e?.message);
    }
    setOpen(false);
  };

  return (
    <Modal open={true} onClose={() => setOpen(false)}>
      <Box className="outline-none flex justify-center items-center h-screen">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 relative"
        >
          {/* Close Button */}
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 text-gray-500 hover:text-red-600 text-xl"
          >
            <IoClose />
          </button>

          {/* Title */}
          <div className="flex items-center gap-3 mb-4">
            <IoPersonAddSharp className="text-2xl text-green-600" />
            <h2 className="text-xl font-bold text-gray-800">
              Add Partner in this Project
            </h2>
          </div>

          {/* Project Title */}
          <p className=" text-gray-500 mb-6">
            <span className="font-medium text-gray-700">Project Title:</span>{" "}
            {projectData?.projectName || "N/A"}
          </p>

          {/* Dropdown */}
          <div className="mb-6">
            <label className="block  font-medium text-gray-700 mb-1">
              Select Partner
            </label>
            <select
              value={selectedPartner}
              onChange={(e) => setSelectedPartner(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 focus:outline-none"
            >
              <option value="">-- Select Partner --</option>
              {partnersList.map((item, index) => (
                <option key={index} value={item?.id}>
                  {`${item?.fullName} (${item?.organization})`}
                </option>
              ))}
            </select>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3">
            <button
              onClick={() => setOpen(false)}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleAddPartner}
              disabled={!selectedPartner}
              className="flex items-center gap-2 px-5 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50"
            >
              <FaPlus /> Add
            </button>
          </div>
        </motion.div>

        {loading && <LoadingComponent />}
      </Box>
    </Modal>
  );
};
